import { getOr } from '@/utils/options';
import { formatLink } from '@/utils/utils';
import { Paragraph } from 'components/src/typography';
import Link from 'next/link';
import * as React from 'react';
import { Maybe, SearchSuggestionFieldsFragment } from 'types/generated';

type Props = {
  suggestions: Array<Maybe<SearchSuggestionFieldsFragment>>;
  onItemClicked: (item: string) => void;
};

const SearchSuggestions = ({ suggestions, onItemClicked }: Props) => {
  return suggestions.map((suggestion, index) =>
    suggestion?.uri ? (
      <Link
        key={suggestion.id}
        className="mt-8 grid w-full first:mt-0 hover:cursor-pointer hover:underline hover:decoration-red-100"
        href={formatLink(suggestion.uri)}
      >
        <Paragraph classes="text-md-fixed text-red-100"> {getOr(suggestion?.title, '')}</Paragraph>
      </Link>
    ) : (
      <div
        key={getOr(suggestion?.id, index.toString())}
        tabIndex={0}
        onClick={() => onItemClicked(getOr(suggestion?.title, ''))}
        className="mt-8 grid w-full first:mt-0 hover:cursor-pointer hover:underline hover:decoration-red-100"
      >
        <Paragraph classes="text-md-fixed text-red-100"> {getOr(suggestion?.title, '')}</Paragraph>
      </div>
    )
  );
};
export default SearchSuggestions;
